(() => {
  const pilotSelector = '.iphone17-product-pilot';
  const barSelector = '[data-iphone17-mobile-buybar]';

  const getMainControls = () => {
    const pilot = document.querySelector(pilotSelector);
    const form = pilot?.querySelector('form.js-product-form');

    return {
      pilot,
      form,
      addButton: form?.querySelector('button[name="add"]'),
      paymentButton: form?.querySelector(
        'button.shopify-payment-button__button--unbranded, .shopify-payment-button__button--branded [role="button"]'
      )
    };
  };

  const getSelectedDevice = (pilot) => {
    const selectedOptions = pilot?.querySelectorAll(
      'input[name]:checked, select[name]'
    );

    for (const control of selectedOptions || []) {
      const optionName = control.getAttribute('name')
        ?.replace(/^options\[/, '')
        ?.replace(/\]$/, '')
        ?.replace(/-\d+$/, '')
        ?.toLowerCase();

      if (optionName && /(model|device|compatibility)/.test(optionName)) {
        return control.value?.replace(/^For\s+/i, '')?.trim() || '';
      }
    }

    return '';
  };

  const syncFitLabel = (pilot, selectedDevice) => {
    const fitLabel = pilot?.querySelector('[data-pilot-fit]');
    if (!fitLabel || !selectedDevice) return;

    const prefix = fitLabel.dataset.fitPrefix
      || fitLabel.textContent.split(':')[0]?.trim()
      || 'Model';
    fitLabel.dataset.fitPrefix = prefix;
    const nextLabel = `${prefix}: ${selectedDevice}`;
    if (fitLabel.textContent.trim() !== nextLabel) fitLabel.textContent = nextLabel;
  };

  const syncBar = (bar) => {
    const addProxy = bar.querySelector('[data-mobile-buybar-add]');
    const buyProxy = bar.querySelector('[data-mobile-buybar-buy]');
    const status = bar.querySelector('[data-mobile-buybar-status]');
    const title = bar.querySelector('[data-mobile-buybar-title]');
    const device = bar.querySelector('[data-mobile-buybar-device]');
    const price = bar.querySelector('[data-mobile-buybar-price]');
    const { pilot, addButton } = getMainControls();
    const addLabel = addButton?.querySelector('span')?.textContent?.trim();
    const unavailable = !addButton || addButton.disabled;
    const mainError = pilot
      ?.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message')
      ?.textContent?.trim();
    const mainTitle = pilot?.querySelector('.prd-block-name')?.textContent?.trim();
    const mainPrice = pilot
      ?.querySelector('.prd-block-price .prd-price-regular')
      ?.textContent?.trim();
    const selectedDevice = getSelectedDevice(pilot);

    if (mainTitle && title && title.textContent.trim() !== mainTitle) title.textContent = mainTitle;
    syncFitLabel(pilot, selectedDevice);
    if (selectedDevice && device && device.textContent.trim() !== `Fits ${selectedDevice}`) {
      device.textContent = `Fits ${selectedDevice}`;
    }
    if (mainPrice && price && price.textContent.trim() !== mainPrice) price.textContent = mainPrice;

    if (addLabel && addProxy.textContent.trim() !== addLabel) addProxy.textContent = addLabel;
    if (addProxy.disabled !== unavailable) addProxy.disabled = unavailable;

    if (buyProxy.disabled !== unavailable) buyProxy.disabled = unavailable;

    if (mainError) {
      if (status.textContent !== mainError) status.textContent = mainError;
      if (status.hidden) status.hidden = false;
    } else if (!status.dataset.localError) {
      if (!status.hidden) status.hidden = true;
      status.textContent = '';
    }
  };

  const resetDock = (host, popup) => {
    host.classList.remove('iphone17-buybar-docked');
    popup.style.removeProperty('position');
    popup.style.removeProperty('top');
    popup.style.removeProperty('bottom');
    popup.style.removeProperty('transform');
  };

  const dockAtFooter = (host, popup, footer) => {
    const footerRect = footer.getBoundingClientRect();
    if (footerRect.top > window.innerHeight) {
      resetDock(host, popup);
      return;
    }

    popup.style.position = 'absolute';
    popup.style.setProperty('bottom', 'auto', 'important');
    popup.style.transform = 'none';
    const offsetParent = popup.offsetParent;
    const parentTop = offsetParent && offsetParent !== document.body
      ? window.scrollY + offsetParent.getBoundingClientRect().top
      : 0;
    const footerTop = window.scrollY + footerRect.top;

    popup.style.top = `${footerTop - parentTop - popup.offsetHeight}px`;
    host.classList.add('iphone17-buybar-docked');
  };

  const compactFooter = () => {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    document.querySelectorAll('.page-footer .collapsed-mobile.open').forEach((block) => {
      block.classList.remove('open');
    });
  };

  const positionBar = () => {
    const host = document.querySelector('sticky-addtocart');
    const popup = host?.querySelector('.sticky-add-to-cart');
    if (!window.matchMedia('(max-width: 767px)').matches) {
      if (host && popup) resetDock(host, popup);
      return;
    }

    const footer = document.querySelector('.page-footer');
    const cookieBanner = document.querySelector('#pandectes-banner');
    if (!host || !popup) return;

    if (!host.classList.contains('ajax-loaded') && typeof host.loadAjax === 'function') {
      host.loadAjax();
      return;
    }

    if (!popup.querySelector(barSelector)) return;

    const cookieBannerVisible = cookieBanner
      && window.getComputedStyle(cookieBanner).display !== 'none'
      && !cookieBanner.classList.contains('cc-invisible');
    const buybarSuspended = cookieBannerVisible;

    host.classList.toggle('iphone17-buybar-suspended', buybarSuspended);
    document.body.classList.toggle('has-iphone17-buybar-ready', !buybarSuspended);
    if (buybarSuspended) {
      resetDock(host, popup);
      document.body.classList.remove('has-sticky-addtocart');
      return;
    }

    popup.classList.add('sticky-add-to-cart--open');
    document.body.classList.add('has-sticky-addtocart');
    if (footer) dockAtFooter(host, popup, footer);
  };

  const runBuyNow = async (trigger, status) => {
    const { form, addButton, paymentButton } = getMainControls();
    if (!form || !addButton || addButton.disabled || trigger.disabled) return;

    const nativePaymentDisabled = paymentButton?.disabled
      || paymentButton?.getAttribute('aria-disabled') === 'true';

    if (paymentButton && !nativePaymentDisabled) {
      paymentButton.click();
      return;
    }

    const originalLabel = trigger.textContent;
    trigger.disabled = true;
    trigger.setAttribute('aria-busy', 'true');
    trigger.textContent = 'Processing…';

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });

      if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
      window.location.assign(`${root}checkout`);
    } catch (error) {
      console.error(error);
      if (status) {
        status.dataset.localError = 'true';
        status.textContent = 'We could not start checkout. Please try again.';
        status.hidden = false;
      }
      trigger.textContent = 'Try again';
      trigger.disabled = false;
      trigger.removeAttribute('aria-busy');
      window.setTimeout(() => {
        if (status) {
          delete status.dataset.localError;
          status.textContent = '';
          status.hidden = true;
        }
        trigger.textContent = originalLabel;
      }, 2000);
    }
  };

  const initialiseDesktopBuy = () => {
    const trigger = document.querySelector('[data-iphone17-desktop-buy]');
    const { addButton } = getMainControls();
    if (!trigger) return;
    trigger.disabled = !addButton || addButton.disabled;
    if (trigger.dataset.initialised === 'true') return;
    trigger.dataset.initialised = 'true';
    const status = document.querySelector('[data-iphone17-desktop-buy-status]');
    trigger.addEventListener('click', () => runBuyNow(trigger, status));
  };

  const initialiseBar = (bar) => {
    if (bar.dataset.initialised === 'true') return;
    bar.dataset.initialised = 'true';

    const addProxy = bar.querySelector('[data-mobile-buybar-add]');
    const buyProxy = bar.querySelector('[data-mobile-buybar-buy]');

    addProxy.addEventListener('click', () => {
      const { form, addButton } = getMainControls();
      if (!form || !addButton || addButton.disabled) return;
      form.requestSubmit(addButton);
    });

    buyProxy.addEventListener('click', () => {
      runBuyNow(buyProxy, bar.querySelector('[data-mobile-buybar-status]'));
    });

    syncBar(bar);
  };

  let syncFrame;
  const syncAllBars = () => {
    window.cancelAnimationFrame(syncFrame);
    syncFrame = window.requestAnimationFrame(() => {
      document.querySelectorAll(barSelector).forEach((bar) => {
        initialiseBar(bar);
        syncBar(bar);
      });
      initialiseDesktopBuy();
      positionBar();
    });
  };

  const start = () => {
    compactFooter();
    syncAllBars();
    window.customElements?.whenDefined('sticky-addtocart').then(syncAllBars);
    window.addEventListener('scroll', syncAllBars, { passive: true });
    document.addEventListener('change', syncAllBars);
    window.addEventListener('resize', () => {
      compactFooter();
      syncAllBars();
    });
    new MutationObserver(syncAllBars).observe(document.body, {
      attributes: true,
      attributeFilter: ['disabled', 'hidden'],
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
